import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flightShortPrice',
  standalone: true,
})
export class FlightShortPricePipe implements PipeTransform {
  transform(price: number): number {
    if (isNaN(price) || price < 0) {
      return price; // Handle invalid input gracefully
    }

    if (price > 1000 && price.toString().endsWith('000')) {
      return price / 1000;
    }

    return price;
  }
}
